import { ChatNiceIdScreen } from '~/chat/components/chat-screen/ChatNiceIdScreen';

export default ChatNiceIdScreen;
